/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";

export const ADD_ONBOARDING_STEP = gql`
  mutation AddOnboardingStep($input: AddOnboardingStepInput!) {
    addOnboardingStep(input: $input)
  }
`;
